import {Grid} from '@material-ui/core';
import {P} from 'components/TypographyShortcuts';
import {PBold} from 'components/TypographyShortcuts';

const HomeScreenWith = ({
    checklistText = 'The Renewal and Upgrade Tabs are Checklist that will guide you on what is needed for the type of USCG License Application you are working on.',
}) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <PBold align='center'>Home Screen</PBold>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    MM-SEAS Checklists
                </PBold>
                <P>{checklistText}</P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Upcoming Dates
                </PBold>
                <P>
                    All of your expirations and dates you need to submit
                    paperwork to the USCG are listed in Upcoming Dates.
                </P>
            </Grid>
            <Grid item xs={12}>
                <PBold paragraph={false} align='center'>
                    Perfect Application
                </PBold>
                <P>
                    When you have completed the Checklist MM-SEAS can submit
                    your application for you! We will double check everthing
                    behind the scenes and deal with the NMC for you.
                </P>
            </Grid>
        </Grid>
    );
};

const HomeScreenWithout = () => {
    return (
        <HomeScreenWith checklistText='The Checklist will guide you on what is needed to get your USCG License. ' />
    );
};

export default HomeScreenWith;
export {HomeScreenWith, HomeScreenWithout};
